import React, { useEffect, useRef } from 'react';
import {
  View,
  Text,
  FlatList,
  ScrollView,
  DeviceEventEmitter,
} from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { useCssStyle } from '../../customHook/getCssStyle';
import CustomPressable from '../../components/customPressable/customPressable';
import { CHEVRON_RIGHT, EXTERNAL_LINK } from '../../assets';
import Header from '../../components/Header/Header';
import { handleLocationSelect } from '../../js/hotelSelector';
import { ImageComp } from '../../components/Image/Image';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { useTranslation } from 'react-i18next';
import CustomFlatList from '../../components/customFlatList';
import { getCleanUrl } from '../../utils/Helper';
import { setGoHome, setProceedHotelSelection } from '../../Redux/Reducers/appConfigReducer';
import { current_client_config, master_client_config } from '../../config/Constant';
import { setRenderLoader } from '../../Redux/Actions/appConfigAction';

const HotelListWidget = (props) => {

  const { tabDetails } = props || {};

  const { hotelListData } = useSelector(state => state.hotelSelectorSlice);
  const { currentWidget, currentLayout } = useSelector(state => state.deviceConfigSlice);
  const { isLoggedIn } = useSelector(state => state.appConfigSlice);

  const getStyles = useCssStyle();
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const mainScrollRef = useRef(null);
  const mainEventListener = useRef(null);

  const hotelListsInfo = hotelListData?.payload?.data;

  const handleItemClick = (hotel) => {
    if(hotel?.hotelPropertyKey){
      dispatch(setProceedHotelSelection({init: true, hotel_Code: hotel.hotelPropertyKey, forceContinue: false}));
    }
  }

  useEffect(() => {
    if (!mainEventListener?.current) {
      mainEventListener.current = DeviceEventEmitter.addListener('scrollToTop', (eventTabDetails) => {
        if (eventTabDetails.uniqueKey === tabDetails.uniqueKey) {
          mainScrollRef?.current?.scrollTo?.({ y: 0, animated: true });
        }
      });
    }
  
    return () => {
      mainEventListener?.current?.remove();
      mainEventListener.current = null;
    };
  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const renderItem = ({ item, index }) => {
    return (
      <CustomPressable 
        style={getStyles([
          'list_itemContainer', 'hotelListWidgetChildContainer_itemContainer', 
          current_client_config?.includes(item.hotelPropertyKey) ? 'hotelListWidgetChildContainer_itemContainer_highlight' : '', 
          master_client_config?.includes(item.hotelPropertyKey) ? 'hotelListWidgetChildContainer_itemContainer_master' : ''
        ])} 
        onPress={() => handleItemClick(item)}>

        {item.hotelBannerImageUrl &&
          <ImageComp
            source={item.hotelBannerImageUrl}
            style={getStyles(['list_itemContainer_image', 'hotelListWidgetChildContainer_itemContainer_image'])}
          />
        }

        <View style={getStyles(['list_itemContainer_textContainer', 'hotelListWidgetChildContainer_itemContainer_textContainer'])}>
          <Text style={getStyles(['list_itemContainer_textContainer_title', 'hotelListWidgetChildContainer_itemContainer_textContainer_title'])}>{item.hotelName}</Text>
          {item.hotelAddress && (
            <Text style={getStyles([ 'list_itemContainer_textContainer_subtitle', 'hotelListWidgetChildContainer_itemContainer_textContainer_subtitle'])} numberOfLines={2} ellipsizeMode="tail">{item.hotelAddress}</Text>
          )}
          {item.hotelAboutInfo && (
            <Text style={getStyles([ 'list_itemContainer_textContainer_subtitle', 'hotelListWidgetChildContainer_itemContainer_textContainer_subtitle'])} numberOfLines={2} ellipsizeMode="tail">{item.hotelAboutInfo}</Text>
          )}
        </View>

        <View style={getStyles(['list_itemContainer_arrow', 'hotelListWidgetChildContainer_itemContainer_arrow'])}>
          {
            item.hotelIsAppSupported ?
              <ImageComp source={CHEVRON_RIGHT} />
              :
              <ImageComp source={EXTERNAL_LINK} />
          }
        </View>
      </CustomPressable>
    );
  };

  const renderRegion = ({ item: regionItem }) => {
    return (
    <View style={getStyles(['hotelListWidgetChildContainer', `hotelListWidgetChildContainer_${regionItem.order}`])} id={`hotelListWidgetChildContainer hotelListWidgetChildContainer_${regionItem.order}`}>
      {regionItem.region && <Text style={getStyles(['hotelListWidgetChildContainerTitle'])} id='hotelListWidgetChildContainerTitle'>{regionItem.region}</Text>}
      <CustomFlatList
        data={regionItem.hotelList}
        renderItem={renderItem}
        keyExtractor={(item, idx) => idx.toString()}
        contentContainerStyle={getStyles(['hotelListWidgetChildContainer_items_container'])}
      />
    </View>
  );}


  const renderHeader = () => (


    <View style={getStyles(['widgetmainContainerHeaderContainer', 'hotelListWidgetHeaderContainer'])}>
      {
        currentWidget?.widgetHeaderImageUrl ?
          <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'hotelListWidgetHeaderImg'])} />
          :
          <ImageComp source={getCleanUrl(currentLayout?.brandingInfo?.launcherBgImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'hotelListWidgetHeaderImg'])} />
      }
      <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'hotelListWidgetHeaderTitleContainer'])}>
        <Text style={getStyles(['widgetmainContainerHeaderTitle', 'hotelListWidgetHeaderTitle'])}>{t('hotelListWidget.heading')}</Text>
        <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'hotelListWidgetHeaderSubTitle'])}>{t('hotelListWidget.sub_heading')}</Text>
      </View>
    </View>
  );



  return (
    <View style={getStyles(['widgetRootContainer', 'hotelListWidgetRootContainer'])}>

      {currentWidget.widgetType ? <HeaderWithBack /> : <Header />}


      {!hotelListsInfo?.length ?
        <ScrollView>
          {renderHeader()}
          <View style={getStyles(['hotelListErrorContainer'])}>
            <Text style={getStyles(['hotelListErrorContainerText'])}>
              {t('hotelListWidget.something_went_wrong')}
            </Text>
          </View>
        </ScrollView>
        :
        <ScrollView ref={mainScrollRef} contentContainerStyle={getStyles(['widgetmainContainer', 'hotelListWidgetMainContainer'])} showsVerticalScrollIndicator={false} >
          {renderHeader()}
          <CustomFlatList
            data={hotelListsInfo}
            renderItem={renderRegion}
            keyExtractor={(item, index) => index.toString()}
            showsVerticalScrollIndicator={false}
            contentContainerStyle={getStyles(['widgetmainContainerChildContainer', 'hotelListWidgetMainContainerChildContainer'])}
          />
        </ScrollView>
      }

    </View >
  );
};

export default React.memo(HotelListWidget);
